import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {RootState} from '../../../../../store/redux';

import attention from '../../../../../assets/image/attention.png';
import DotsLoading from '../../../../../components/dotsLoading';
import CardInputGroup from '../../../../../components/mazraeKit/CardInputGroup';
import MyStoreCard from '../../../../../components/mazraeKit/cards/myStoreCard';
import CustomSearchBox from '../../../../../components/mazraeKit/customSearchBox';
import MainFooter from '../../../../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../../../../components/mazraeKit/headers/homeHeader';
import {useGetInputGroupList} from '../../../../../services/hookService';
import useGetStoreAds from '../../../../../services/hookService/getStoreAds/useGetStoreAds';
import {clearFilter} from '../../../../../store/redux/myStore';
import useDebounce from '../../../../../utilities/hooks/useDebounce/useDebounce';
import {CodeToInputGroupName} from '../../../myFavouriteAdd/card/helper';
import MyLabFilterBottomSheet from '../../elements/bottomSheetLists/myLabFilterBottomSheet';
import MyLabFiltersAdvertisement from '../../elements/myLabFiltersAdvertisementList';

const MyLabAdvertisement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const {store_guid} = useParams();

  const [inputValue, setInputValue] = useState<string>('');
  const [openBottomSheet, setOpenBottomSheet] = useState(false);
  const [advertisementCode, setAdvertisementCode] = useState(0);

  const debouncedValue = useDebounce(inputValue, 2000);
  const {inputGroupList} = useGetInputGroupList();

  const onClickHandler = (
    item: Omit<IInputGroup, 'title_description' | 'icon'>,
  ) => {
    setAdvertisementCode(item.code as number);
  };

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };
  const state = useSelector((state: RootState) => state.myStore);

  const payload = {
    search: debouncedValue || undefined,
    order_by: state.sorting || undefined,
    advertisement_type:
      advertisementCode !== 0
        ? CodeToInputGroupName[advertisementCode]
        : undefined,
    status_list:
      Object.keys(state.status_list)
        .filter(
          //@ts-ignore
          (key: string) => state.status_list[key],
        )
        .join(',') || undefined,
    // store_guid: store_guid,
  };

  const {data, isLoading, loaderRef, isFetchingNextPage} =
    useGetStoreAds(payload);

  return (
    <div className="relative flex flex-col w-full h-full">
      <CustomHeader
        title="آگهی‌های آزمایشگاه من"
        isActiveRightIcon
        preIcon="icon-nameArrow---Right"
        onClick={() => {
          navigate(-1);
          dispatch(clearFilter());
        }}
      />
      {data?.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-full px-3 text-md ">
          <div className="flex flex-col items-center justify-center">
            <img src={attention} alt="" className="w-44 h-44" />
            <span className="mb-6 font-Medium">ثبت اولین آگهی</span>
          </div>
          <span>
            آزمایشگاه شما هیچ آگهی‌ ندارد.
            <br /> همین حالا اولین آگهی فروش محصول یا خدمات خود را منتشر کنید...
          </span>
          <button
            className="py-3 mt-6 text-white rounded bg-farm-shop-500 w-52"
            onClick={() => navigate('/advertisement-registeration')}
          >
            ثبت آگهی
          </button>
        </div>
      ) : (
        <>
          <div className="w-full px-3 my-3 ">
            <CustomSearchBox
              placeholder="جستجو در آزمایشگاه "
              type="text"
              value={inputValue}
              inputCustomClass="!pr-8"
              isFloating={false}
              preIcon="icon-nameSearch"
              onChange={onChangeHandler}
              {...{inputValue, setInputValue}}
            />
            <div className="flex items-center w-full gap-2 mt-3">
              <button
                className="flex items-center gap-2 px-3 py-2 text-gray-700 border rounded-full w-fit"
                onClick={() => setOpenBottomSheet(true)}
              >
                <i className="font-bold icon-nameFilter text-xxl" />
                <span className="text-sm whitespace-nowrap">فیلتر کردن</span>
              </button>
              <MyLabFiltersAdvertisement />
            </div>
            <div className="flex gap-1 my-2 overflow-x-auto">
              {inputGroupList &&
                inputGroupList.length > 0 &&
                [...inputGroupList.filter(item => item.code === 18)].map(
                  item => {
                    return (
                      <div className="flex justify-start w-full">
                        <CardInputGroup
                          isActive={item.code === advertisementCode}
                          isBoled={false}
                          title={item.title}
                          image={item.image}
                          guid={item.guid}
                          clickHandler={() => onClickHandler(item)}
                        />
                      </div>
                    );
                  },
                )}
            </div>
          </div>
          <section className="flex flex-col h-full gap-4 px-3 overflow-y-auto ">
            {isLoading ? (
              <DotsLoading />
            ) : (
              <>
                {data?.map((item: INewAdvData, index: number) => (
                  <MyStoreCard
                    title={item.title}
                    storeName={item.store?.title}
                    rate={item.rate}
                    image={item.main_image?.image}
                    discount_amount={item.discount_amount}
                    created_at={item.created_at}
                    advertisementGuid={item.id}
                  />
                ))}
              </>
            )}
          </section>
          {/* This div acts as a sentinel for triggering infinite scroll */}
          <div ref={loaderRef} className="mt-4 text-center">
            {isFetchingNextPage ? <DotsLoading /> : null}
          </div>
        </>
      )}

      <MyLabFilterBottomSheet {...{openBottomSheet, setOpenBottomSheet}} />
      <MainFooter />
    </div>
  );
};

export default MyLabAdvertisement;
